// Definição para o modal de busca de Tabelas de Preços Comercial filtrada por cliente.
// Usada no Pedido de Venda para selecionar a tabela vinculada ao cliente do pedido.
// O endpoint já retorna apenas tabelas com vínculo vigente + LstStatus = Ativo,
// por isso não são necessários filtrosFixos.

export const criarConfigBuscaPrecoComercialCliente = (idParceiro) => ({
  label: 'Tabela de Preços',
  placeholder: 'Nome da Tabela...',
  titulo: 'Selecionar Tabela de Preços',
  endpointApi: `PrecosComerciais/por-cliente/${idParceiro}`,
  // Endpoint usado para resolver a descrição de um ID já salvo (GET /PrecosComerciais/{id}).
  endpointFetchId: 'PrecosComerciais',
  idField: 'idPrecoComercial',
  displayField: 'idPrecoComercial',
  descField: 'nome',
  tabela: 'PrecoComercial',
  camposFiltro: [
    { label: 'Nome da Tabela', model: 'busca', tipo: 'text' }
  ],
  colunasGrid: [
    { header: 'ID', dataField: 'idPrecoComercial', width: '10%' },
    { header: 'Nome da Tabela', dataField: 'nome', width: '55%' },
    { header: 'Moeda', dataField: 'lstMoeda', width: '15%' },
    { header: 'Status', dataField: 'lstStatus', width: '20%' }
  ]
})
